function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import RestrictUntilAboveContainer from './RestrictUntilAboveContainer';
import classNames from '../../utils/classNames';
/**
 * The layout for "above the fold" content for a PDP with a hero image
 *
 * - [Designs](https://atlas.np.tools.playstation.net/design/ca7a3dbd-ea40-40a0-93c5-f995044e9e54/4?bounds=-0.404,0.117,1.509,0.810&rev=4&x=408.34&y=4494.29)
 */

var HeroPdpTop = /*#__PURE__*/function (_PureComponent) {
  _inherits(HeroPdpTop, _PureComponent);

  var _super = _createSuper(HeroPdpTop);

  function HeroPdpTop(props) {
    var _this;

    _classCallCheck(this, HeroPdpTop);

    _this = _super.call(this, props);
    _this.node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(HeroPdpTop, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          title = _this$props.title,
          backgroundImage = _this$props.backgroundImage,
          cta = _this$props.cta,
          gameRatings = _this$props.gameRatings,
          top8 = _this$props.top8;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.node,
        className: classNames(className, 'psw-l-stack-left', 'psw-fill-x')
      }, /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor psw-fill-x"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-top-left', 'psw-l-top-left', 'psw-fill-x', 'psw-game-background-image-hero-h-max', 'psw-clip')
      }, backgroundImage)), /*#__PURE__*/React.createElement("div", {
        className: "psw-game-background-image-hero-h-min psw-l-exclude@tablet-s"
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor', 'psw-l-z-1', 'psw-l-grid', 'psw-l-gap-y-7')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/12', 'psw-l-exclude@laptop', 'psw-l-exclude@below-tablet-s')
      }), /*#__PURE__*/React.createElement(RestrictUntilAboveContainer, {
        containerRef: this.node,
        className: classNames('psw-pdp-card-anchor', 'psw-l-stack-bottom', 'psw-l-w-1/1', 'psw-l-w-5/12@tablet-s', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/3@laptop', 'psw-l-w-7/24@desktop', 'psw-l-w-7/24@max', 'psw-p-x-5@below-tablet-s')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-stack-bottom', 'psw-game-background-image-hero-h-min', 'psw-m-sub-t-9@below-tablet-s', 'psw-m-t-9')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-c-bg-card-1', 'psw-p-y-7', 'psw-p-x-8', 'psw-m-sub-x-8', 'psw-m-sub-x-6@below-tablet-s', 'psw-p-x-6@below-tablet-s')
      }, /*#__PURE__*/React.createElement("div", null, title), cta && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-7"
      }, cta)))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/24', 'psw-l-exclude@below-tablet-s')
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/1', 'psw-l-w-1/3@tablet-s', 'psw-l-w-5/12@tablet-l', 'psw-l-w-7/12@laptop', 'psw-l-w-2/3@desktop', 'psw-l-w-2/3@max', 'psw-p-x-5@below-tablet-s')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-exclude@below-tablet-s', 'psw-game-background-image-hero-h-min', 'psw-m-b-7')
      }), /*#__PURE__*/React.createElement("div", {
        className: "psw-l-line-repel-top"
      }, top8 && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/3', 'psw-l-w-5/12@desktop', 'psw-l-w-5/12@max', 'psw-l-exclude@below-laptop', 'psw-m-r-5')
      }, top8), gameRatings && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-fill-x', 'psw-fill-x-1/2@laptop')
      }, gameRatings))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/12', 'psw-l-exclude@laptop', 'psw-l-exclude@below-tablet-s')
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/1', 'psw-l-w-5/6@tablet-s', 'psw-l-w-5/6@tablet-l', 'psw-m-x-auto', 'psw-l-exclude@laptop', 'psw-p-x-5@below-tablet-s', 'psw-m-t-7')
      }, top8));
    }
  }]);

  return HeroPdpTop;
}(PureComponent);

HeroPdpTop.defaultProps = {
  className: '',
  title: null,
  backgroundImage: null,
  cta: null,
  gameRatings: null,
  top8: null
};
HeroPdpTop.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  backgroundImage: PropTypes.node,
  cta: PropTypes.node,
  gameRatings: PropTypes.node,
  top8: PropTypes.node
};
export default HeroPdpTop;